module.exports = __webpack_public_path__ + "528f3cc5d97fe9f4a56befeee0212ef0.svg";